import View from './View';

export { default as View, getSearchTextInputStyles } from './View';

export default View;
